module.exports = __webpack_public_path__ + "img/subjective-question.6307e999.svg";